import type { SiteRead } from "../../site-management/services/siteTypes";

export const locationTagTypes: LocationTagType[] = ["LocationList"];
export type LocationTagType = "LocationList";

export type LocationCustomer = {
  company_name: string;
};
export type LocationCustomerRead = {
  id: number;
  company_name: string;
};
export type LocationSite = {
  name: string;
  customer: LocationCustomer;
};
export type LocationSiteRead = {
  id: number;
  name: string;
  customer: LocationCustomerRead;
};
export type Location = {
  site: LocationSite;
  name: string;
};
export type LocationRead = {
  id: number;
  site: SiteRead;
  meter_count: number;
  created_at: string;
  updated_at: string;
  name: string;
};
export type PaginatedLocationList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Location[];
};
export type PaginatedLocationListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: LocationRead[];
};
export type CreateLocation = {
  name: string;
  site: number;
};
export type CreateLocationRead = {
  created_at: string;
  updated_at: string;
  name: string;
  site: number;
};
export type CreateLocationRequest = {
  name: string;
  site: number;
};
export type LocationLocationRequest = {
  company_name: string;
};
export type LocationSiteRequest = {
  name: string;
  Location: LocationLocationRequest;
};
export type LocationRequest = {
  site: LocationSiteRequest;
  name: string;
};
export type PatchedLocationRequest = {
  site?: LocationSiteRequest;
  name?: string;
};

export type LocationsCreateApiResponse = /** status 201  */ CreateLocationRead;
export type LocationsCreateApiArg = {
  createRequest: CreateLocationRequest;
};
export type LocationsRetrieveApiResponse = /** status 200  */ LocationRead;
export type LocationsRetrieveApiArg = {
  id: number;
};
export type LocationsUpdateApiResponse = /** status 200  */ LocationRead;
export type LocationsUpdateApiArg = {
  /** A unique integer value identifying this location. */
  id: number;
  updateRequest: LocationRequest;
};
export type LocationsPartialUpdateApiResponse = /** status 200  */ LocationRead;
export type LocationsPartialUpdateApiArg = {
  /** A unique integer value identifying this location. */
  id: number;
  patchedRequest: PatchedLocationRequest;
};
export type LocationsDestroyApiResponse = unknown;
export type LocationsDestroyApiArg = {
  /** A unique integer value identifying this location. */
  id: number;
};
